import EmployeeSector from "../views/schooladmin/EmployeeSector";
import EmployeeSectorAddEdit from "../views/schooladmin/EmployeeSectorAddEdit";

export default [{
    path: "/schooladmin/employee_sector",
    components: {
      content: EmployeeSector
    }
  },
  {
    path: "/schooladmin/employee_sector/new",
    components: {
      content: EmployeeSectorAddEdit
    }
  },
  {
    path: "/schooladmin/employee_sector/update/:id",
    components: {
      content: EmployeeSectorAddEdit
    },
    props: {
      content: true
    }
  }
];
